import { useEffect, useState } from "react";
import { useLoader } from "../useLoader";
import ApiService from "../../services/ApiServiceClass";


export type namesType = {
    name: string,
    is_primary: boolean,
    totalRequest: number,
    totalCosts: number
}

export type RequestByMemberIDType = {
    id: number,
    title: string,
    description: string,
    category_type: string,
    category: string,
    cost_centre: string,
    status: string,
    status_order: string,
    total_cost: number,
    request_date: string,
    names: namesType[],
    comment_count: number
}

export const useGetRequestByMemberID = () => {
    const [requestsByMemberID, setRequestsByMemberID] = useState<RequestByMemberIDType[]>([]);
    const loader = useLoader();

    const fetchRequestsByMemberID = async () => {

        loader?.setIsLoading(true);
        try {
            const responseData = await ApiService.getRequestByMemberID();
            setRequestsByMemberID(responseData.data);            
            loader?.setIsLoading(false);            
        } catch(error) {
            loader?.setIsLoading(false);
            return null;
        }
    }

    useEffect(() => {
        fetchRequestsByMemberID();
    }, []);

    return {requestsByMemberID, setRequestsByMemberID};
}
